import "../styles/testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Joseph King",
      role: "Donor",
      quote:
        "I'm proud to support CARPE Ministries and their mission to make a difference in the lives of those impacted by drug abuse, domestic violence, and homelessness.",
    },
    {
      name: "Patricia King",
      role: "Volunteer",
      quote:
        "I've been volunteering with CARPE Ministries from day one, and I've seen firsthand the impact they have on the lives of those they serve.",
    },
    {
      name: "Tyrrence Spencer",
      role: "Community Partner",
      quote:
        "CARPE Ministries is an invaluable resource for our church. Their programs and services are making a real difference in our community.",
    },
  ];

  return (
    <section id="testimonials-section">
      <div className="testimonials-header">
        <span>Testimonials</span>
        <h2>What Our Supporters Say</h2>
      </div>

      <div className="container testimonials-grid">
        {testimonials.map((item) => (
          <div className="testimonial-card" key={item.name}>
            <div className="quote-mark">“</div>
            <p>{item.quote}</p>
            <div>
              <h3>{item.name}</h3>
              <span>{item.role}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;